module.exports = __webpack_public_path__ + "img/May Ma.a748c094.jpg";